import { AuthProvider } from "@/auth/provider/AuthProvider";
import { ConfigProvider } from "@/components/config/ConfigProvider";
import { EntityImageProvider } from "@/components/EntityImageProvider";
import { StyleProvider } from "@/components/styles/StyleProvider";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./app/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StyleProvider>
    <ConfigProvider>
      <AuthProvider>
        {/* Ideally StrictMode would be at the top level, but there's a known
            issue with Keycloak and StrictMode that causes a reload loop if the
            keycloak init function (e.g. via AuthProvider) is called more than
            once.

            See https://github.com/react-keycloak/react-keycloak/issues/182
            (not using this library but it's the same issue)
        */}
        <React.StrictMode>
          <EntityImageProvider>
            <App />
          </EntityImageProvider>
        </React.StrictMode>
      </AuthProvider>
    </ConfigProvider>
  </StyleProvider>,
);
